
// const API_HOST = "http://192.168.11.101:8000";                //92   501
const API_HOST = "https://innovaapi.aminer.cn/expreco";
// const API_HOST = "https://innovaapi.aminer.cn/expreco_test";

function userToken() {
    return localStorage.getItem("token_aminer");
}

function logout() {
    localStorage.removeItem("token_aminer");
    document.cookie = null;
}

async function requestResults(id, page, limit, dev_mode=false) {
    let url = `${API_HOST}/tob/recommend/record/${id}/experts/?page=${page}&limit=${limit}${dev_mode ? '&with_anno=true' : ''}`;
    let response = await fetch(url, {
        headers: {
            "content-type": "application/json",
            "Authorization": userToken() || ""
        }
    })
    return response.json();
}

async function requestSearch(body) {
    let url = `${API_HOST}/tob/recommend/expert/`;
    let response = await fetch(url, {
        method: "POST",
        headers: {
            "content-type": "application/json",
            "Authorization": userToken() || ""
        },
        body: JSON.stringify(body)
    })
    return response.json();
}

async function requestCsv(body) {
    let url = `${API_HOST}/tob/recommend/result/csv/`;
    let response = await fetch(url, {
        method: "POST",
        headers: {
            "content-type": "application/json",
            "Authorization": userToken() || ""
        },
        body: JSON.stringify(body)
    })
    return response.blob();
}

async function requestHint(q) {
    let url = `${API_HOST}/tob/recommend/ind_chain/ind/search/?term=${q}`;
    let res =  await fetch(url);
    return res.json();
}

async function requestIndustry() {
    let url = API_HOST + "/tob/recommend/ind_chain/list/";
    let res = await fetch(url);
    return res.json();
}

async function requestIndustryByStr(str) {
    let url = API_HOST + "/tob/recommend/ind_chain/?term=" + str;
    let res = await fetch(url);
    return res.json();
}

async function requestHotWords() {
    let url = `${API_HOST}/tob/recommend/keywords/`;
    let response = await fetch(url)
    return response.json();
}

async function requestLogin(email, password) {
    let url = "https://api.aminer.cn/api/auth/signin";
    let response = await fetch(url, {
        method: "POST",
        headers: {
            "content-type": "application/json"
        },
        body: JSON.stringify({
            email,
            password,
            persist: true,
            src: "expert_reco"
        })
    })
    return response.json();
}

async function resetPassword( identifier,password, src, token) {//新加
    let url = "https://api.aminer.cn/api/auth/update/forgot";
    let response = await fetch(url, {
        method: "POST",
        headers: {
            "content-type": "application/json"
        },
        body: JSON.stringify({
            identifier,
            password,
            src:"expert_reco",
            token
        })
    });
    return response.json();
}


async function requestRetrieve(identifier, password, src, token) {
    let url = "https://api.aminer.cn/api/auth/update/token";
    let response = await fetch(url, {
        method: "POST",
        headers: {
            "content-type": "application/json"
        },
        body: JSON.stringify({
            identifier,
            password,
            src,
            token
        })
    });
    return response.json();
}

async function requestHistory(page, limit) {
    let url = `${API_HOST}/tob/recommend/record/list/?page=${page}&limit=${limit}`;
    let response = await fetch(url, {
        headers: {
            "Authorization": userToken() || ""
        }
    });
    return response.json();
}

async function requestExtractor(text) {
    let url = `${API_HOST}/keywords/extractor/?text=${text}`;
    let response = await fetch(url);
    return response.json();
}

async function requestSignup(email, first_name, last_name, gender) {
    let url = "https://api.aminer.cn/api/auth/signup";
    let response = await fetch(url, {
        method: "POST",
        headers: {
            "content-type": "application/json"
        },
        body: JSON.stringify({
            email,
            first_name,
            last_name,
            gender,
            position: 8,
            src: "expert_reco",
            sub: false,
        })
    })
    return response.json();
}

async function requestUserInfo(token) {
    let url = "https://apiv2.aminer.cn/magic?a=ME__user.GetMe__";
    let response = await fetch(url, {
        method: "POST",
        headers: {
            "content-type": "application/json",
            "Authorization": token
        },
        body: JSON.stringify([
            {
                action: "user.GetMe"
            }
        ])
    })
    return response.json();
}

async function requestPapers(ids) {
    let url = "https://apiv2.aminer.cn/magic?a=__search.search___";
    let body = [
        {
          "action":"search.search",
          "parameters":{
              "ids":ids,
              "size": ids.length,
              "searchType": "all"
          },
          "schema":{
              "publication":[
                  "id",
                  "year",
                  "title",
                  "title_zh",
                  "abstract_zh",
                  "abstract",
                  "authors",
                  "authors._id",
                  "authors.name",
                  "authors.name_zh",
                  "num_citation",
                  "venue.info.name",
                  "venue.volume",
                  "venue.info.name_zh",
                  "venue.info.publisher",
                  "venue.issue",
              ]
          }
      }
    ];
    let response = await fetch(url, {
        method: "POST",
        headers: {
            "content-type": "application/json"
        },
        body: JSON.stringify(body)
    });
    return response.json();
}

async function requestPersons(ids) {
    let url = "https://apiv2.aminer.cn/magic?a=__search.search___";
    let body = [
        {
          "action":"search.search",
          "parameters":{
              "ids":ids,
              "size": ids.length,
          },
          "schema":{
              "person":[
                  "id",
                  "name",
                  "title",
                  "name_zh",
                  "avatar",
                  "bind",
                  "tags",
                  {
                      "profile":[
                          "position",
                          "position_zh",
                          "affiliation",
                          "affiliation_zh",
                          "bio",
                          "org",
                          "org_zh"
                      ]
                  },
                  {
                      "indices":[
                          "hindex",
                          "gindex",
                          "pubs",
                          "citations",
                          "newStar",
                          "risingStar",
                          "activity",
                          "diversity",
                          "sociability"
                      ]
                  }
              ]
          }
      }
    ];
    let response = await fetch(url, {
        method: "POST",
        headers: {
            "content-type": "application/json"
        },
        body: JSON.stringify(body)
    });
    return response.json();
}

async function requestAnnotation(resultId, pid, data) {
    let url = `${API_HOST}/tob/recommend/annotation/`;
    console.log(url);
    let response = await fetch(url, {
        method: "POST",
        headers: {
            "content-type": "application/json",
            "Authorization": userToken() || ""
        },
        body: JSON.stringify({
            "record_id": resultId,
            "person_id": pid,
            "anno_type": "double_value",
            "anno_data": data,
            "comment": ""
        })
    });
    return response.json();
}

async function requestMyFavList() {
    let url = "https://apiv2.aminer.cn/magic?a=TreeData__expertbase.search.myeb___";
    let response = await fetch(url, {
        method: "POST",
        headers: {
            "content-type": "application/json",
            "Authorization": userToken() || ""
        },
        body: JSON.stringify([{
            "action":"expertbase.search.myeb",
            "parameters":{
                "offset":0,
                "size":1000
            },
            "schema":{
                "expertbase":[
                    "name",
                    "name_zh",
                    "logo",
                    "order",
                    "type",
                    "stats",
                    "parents",
                    "is_deleted",
                    "is_public",
                    "price",
                    "report_link",
                    "order"]
            }
        }])
    });
    return response.json();
}

async function requestCreateFavList(name, desc) {
    let url = "https://apiv2.aminer.cn/magic?a=Alter__expertbase.Alter___";
    let response = await fetch(url, {
        method: "POST",
        headers: {
            "content-type": "application/json",
            "Authorization": userToken() || "",
            "debug": 1
        },
        body: JSON.stringify([{
            "action":"expertbase.Alter",
            "parameters":{
                "opts":[{
                    "operator":"upsert",
                    "fields":[{
                        "field":"parents",
                        "value":[]
                    },
                    {
                        "field":"name_zh",
                        "value":name
                    },
                    {
                        "field":"desc_zh",
                        "value":desc
                    },
                    {
                        "field":"is_public",
                        "value":true
                    }]
                }]
            }
        }])
    });
    return response.json();
}

async function requestRemoveFavList(id) {
    let url = "https://apiv2.aminer.cn/magic?a=Delete__expertbase.Delete___";
    let response = await fetch(url, {
        method: "POST",
        headers: {
            "content-type": "application/json",
            "Authorization": userToken() || ""
        },
        body: JSON.stringify([{
            "action":"expertbase.Delete",
            "parameters":{
                "ids":[
                    id
                ],
                "real":false
            }
            
        }])
    })
    return response.json();
}

async function requestAddToFavList(aid, eid) {
    let url = "https://apiv2.aminer.cn/magic?a=AddExpertToEB__person_eb.alter___";
    let response = await fetch(url, {
        method: "POST",
        headers: {
            "content-type": "application/json",
            "Authorization": userToken() || ""
        },
        body: JSON.stringify([{
            "action":"person_eb.alter",
            "parameters":{
                "opts":[{
                    "aid":aid,
                    "eid":eid,
                    "opt":"add"
                }]
            }
        }])
    })
    return response.json();
}

async function requestRemoveFromFavList(aid, eid) {
    let url = "https://apiv2.aminer.cn/magic?a=AddExpertToEB__person_eb.alter___";
    let response = await fetch(url, {
        method: "POST",
        headers: {
            "content-type": "application/json",
            "Authorization": userToken() || ""
        },
        body: JSON.stringify([{
            "action":"person_eb.alter",
            "parameters":{
                "opts":[{
                    "aid":aid,
                    "eid":eid,
                    "opt":"remove"
                }]
            }
        }])
    })
    return response.json();
}

async function requestFavListDetails(id, offset, size) {
    let url = "https://apiv2.aminer.cn/magic?a=SEARCH__expertbase.search.gctsearch___";
    let response = await fetch(url, {
        method: "POST",
        headers: {
            "content-type": "application/json",
            "Authorization": userToken() || ""
        },
        body: JSON.stringify([{
            "action":"expertbase.search.gctsearch",
            "parameters":{
                "searchType":"ToBPerson",
                "offset":offset,
                "size":size,
                "aggregation":[
                    "gender",
                    "h_index",
                    "nation",
                    "lang"
                ],
                "switches":[
                    "lang_zh",
                    "intell_expand"
                ],
                "filters":{
                    "dims":{
                        "eb":[
                            id
                        ]
                    }
                }
            },
            "schema":{
                "person":[
                    "id",
                    "name",
                    "title",
                    "name_zh",
                    "avatar",
                    "tags",
                    {"profile":[
                        "position",
                        "position_zh",
                        "affiliation",
                        "affiliation_zh",
                        "org",
                        "org_zh"
                    ]},
                    {"indices":[
                        "hindex",
                        "gindex",
                        "pubs",
                        "citations",
                        "newStar",
                        "risingStar",
                        "activity",
                        "diversity",
                        "sociability"
                    ]},
                    "tags_translated_zh"
                ]
            }
        }])
    })
    return response.json();
}

export {
    resetPassword,//新建
    requestSearch,
    requestPersons,
    requestPapers,
    requestHotWords,
    requestLogin,
    requestSignup,
    userToken,
    requestUserInfo,
    logout,
    requestExtractor,
    requestResults,
    requestRetrieve,
    requestHistory,
    requestMyFavList,
    requestCreateFavList,
    requestAddToFavList,
    requestFavListDetails,
    requestRemoveFromFavList,
    requestRemoveFavList,
    requestHint,
    requestIndustry,
    requestIndustryByStr,
    requestCsv,
    requestAnnotation
}


//加入智库
//https://apiv2.aminer.cn/magic?a=AddExpertToEB__person_eb.alter___
//POST
/**
 * [{"action":"person_eb.alter","parameters":{"opts":[{"aid":"53f48bb9dabfaea7cd1ccb20","eid":"5e782205a7058c6e3598da83","opt":"add"}]}}]
 */

 //我的人才库
 //https://apiv2.aminer.cn/magic?a=TreeData__expertbase.search.myeb___
 //post
 //[{"action":"expertbase.search.myeb","parameters":{"offset":0,"size":1000},"schema":{"expertbase":["name","name_zh","logo","order","type","stats","parents","is_deleted","is_public","price","report_link","order"]}}]

 //人才库list
 //https://apiv2.aminer.cn/magic?a=SEARCH__expertbase.search.gctsearch___
 //POST
 //[{"action":"expertbase.search.gctsearch","parameters":{"searchType":"ToBPerson","offset":0,"size":20,"aggregation":["gender","h_index","nation","lang"],"switches":["lang_zh","intell_expand"],"haves":{"eb":["5e781f48a7058c6e35929b60","5e782205a7058c6e3598da83","5e78221fa7058c6e35990c64","5e782277a7058c6e3599cfdc","5e7822d7a7058c6e359a8bf3","5e7822e2a7058c6e359aa547","5e7b378ca7058c6e3583fe2a","5e7b37dea7058c6e358473b8"]},"filters":{"dims":{"eb":["5e781f48a7058c6e35929b60"]}}},"schema":{"person":["id","name","title","name_zh","avatar","tags",{"profile":["position","position_zh","affiliation","affiliation_zh","org","org_zh"]},{"indices":["hindex","gindex","pubs","citations","newStar","risingStar","activity","diversity","sociability"]},"tags_translated_zh"]}}]

 //库详情
 //https://apiv2.aminer.cn/magic?a=getExpertBases__expertbase.search.gctsearch___
 //POST
 //[{"action":"expertbase.search.gctsearch","parameters":{"ids":["5e781f48a7058c6e35929b60"],"offset":0,"size":1000,"searchType":"all","switches":["master"],"filters":{"terms":{"system":["expertbase"]}}},"schema":{"expertbase":["name","name_zh","logo","type","stats","is_deleted","parents","is_public","price","report_link","order","desc","desc_zh","created_time","updated_time","creator","system","related_venues","labels","all_stats"]}}]

 //移出智库
 //https://apiv2.aminer.cn/magic?a=AddExpertToEB__person_eb.alter___
 //POST
 //[{"action":"person_eb.alter","parameters":{"opts":[{"aid":"53f57ebadabfaea0a5f8045d","eid":"5e781f48a7058c6e35929b60","opt":"remove"}]}}]

 //删除智库
 //https://apiv2.aminer.cn/magic?a=Delete__expertbase.Delete___
 //POST
 //[{"action":"expertbase.Delete","parameters":{"ids":["5e781f48a7058c6e35929b60"],"real":false}}]

 //添加智库
 //https://apiv2.aminer.cn/magic?a=Alter__expertbase.Alter___
 //POST
 //[{"action":"expertbase.Alter","parameters":{"opts":[{"operator":"upsert","fields":[{"field":"parents","value":[]},{"field":"name_zh","value":"111"},{"field":"desc_zh","value":"222"},{"field":"is_public","value":true}]}]}}]